import { atom } from 'jotai';
export const userManagementSearchPlaceholder = atom<string>('Search Users');

export const userManagementSearchTerm = atom<string>('');
